import request from '@/utils/request';
import { iPromoteCode } from '@/interface/promote-code';
/**
 * OMC 获取推广码列表 旧
 * @param data
 */
export const getOldPromoteCodeList = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/promote_code/page_list',
    method: 'get',
  });
/**
 * OMC 获取推广码列表 新
 * @param data
 */
export const getPromoteCodeList = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/promote_code_pack/page_list',
    method: 'get',
  });
/**
 * 导出推广码
 * @param params { cnt: number; version: number }
 */
export const getExcelTable = (data: { id: number }) =>
  request({
    data,
    url: '/api/v1/omc/promote_code_pack/output',
    method: 'post',
  });

/**
 * OMC 启用禁用新
 * @param data
 */
export const updatePackOpen = (data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/promote_code_pack/open',
    method: 'put',
  });
/* OMC 添加推广码列表
 * @param data
 */
export const addPromoteCode = (data: iPromoteCode): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/promote_code_pack',
    method: 'post',
  });

/* OMC 推广码 第三方验证码
 * @param data
 */
export const exportPromoteThirdCode = (data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/promote_code_pack/third',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
/* OMC 推广码 第三方验证码导入追加
 * @param data
 */
export const exportPromoteAddThirdCode = (data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/promote_code_pack/third',
    method: 'put',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

/* OMC【推广码包】修改使用说明
 * @param data
 */
export const exportPromoteUpdateThirdCodeDesc = (data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/promote_code_pack/intro',
    method: 'put',
  });
/* OMC 推广码详情
/**
 * OMC 启用禁用
 * @param data
 */
export const updateOpen = (data: any): Promise<any> =>
  request({
    data,
    url: '/api/v1/omc/promote_code/open',
    method: 'put',
  });

/* OMC 推广码详情
 * @param data
 */
export const getPromoteCodeDetail = (id: number): Promise<any> =>
  request({
    url: '/api/v1/omc/promote_code?id' + id,
    method: 'get',
  });
